<div *ngIf="plans$ | async as plans" class="row custom-container">
  <div class="col-md-4 col-12">
    <div class="card h-100 ">
      <div class="card-body d-flex flex-column align-items-center justify-content-between">
        <div class="w-100">
          <div class="plan-img">
            <img src="../../../../assets/ico/plan1.svg" alt="">
          </div>
          <div class="title">
            <span><strong>{{ plans[0].name }}</strong></span>
          </div>
          <div class="price-container d-flex flex-column">
            <!-- <span class="price-tag"><strong>R$
                <span class="price">{{
                  plans[0].valueTaxaActive | number: "0.2-2"
                  }}</span>
                / mês</strong></span>
            <span class="price-description text-muted">Taxa para ativação</span> -->
            <span class="price-tag">
              <strong>
                <span class="price">Em breve</span></strong>
            </span>
          </div>
          <div class="details">
            <span *ngFor="let detail of plans[0].details">
              <div class="d-flex">
                <p class="tick"><img src="../../../../assets/ico/tick.svg" alt=""></p>
                <p>
                  {{ detail.description }}
                </p>
              </div>
            </span>
          </div>
          <div class="categories">
          </div>
          <!-- <div class="mt-4 input d-flex flex-column gap-2">
            <span>Você pode incluir saldo na sua carteira para lançar
              missões</span>
            <div class="w-100 d-flex justify-content-center">
              <numeric-input class="mb-4" [(ngModel)]="creditBalance[0]" prefix="R$"></numeric-input>
            </div>
          </div> -->
        </div>
        <!-- <div class="w-100 action-button-container">
          <button [disabled]="creditBalance[0] <= 0" (click)="hirePlan(plans[0], 0)"
            class="btn btn-lg btn-primary text-white">
            Contratar
          </button>
        </div> -->
        <div class="w-100 action-button-container">
          <button (click)="knowMe()"
            class="btn btn-lg btn-primary text-white">
            Avise-me
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4 col-12">
    <div class="card h-100">
      <div class="card-body d-flex flex-column align-items-center justify-content-between">
        <div class="w-100">
          <div class="plan-img">
            <img src="../../../../assets/ico/plan2.svg" alt="">
          </div>
          <div class="title">
            <span><strong>{{ plans[1].name }}</strong></span>
          </div>
          <div class="price-container d-flex flex-column">
            <span class="price-tag"><strong>R$
                <span class="price">{{
                  getDedicatedPlanPrice(plans[1]) | number: "0.2-2"
                  }}</span>
                / ano</strong></span>
            <span class="price-description text-muted">Preço mínimo com 10 licenças</span>
          </div>
          <div class="details">
            <span>
              <div class="d-flex">
                <p class="tick"><img src="../../../../assets/ico/tick.svg" alt=""></p>
                <p>
                  10 licenças válidas por 1 ano: usuário root + 9 usuários.
                </p>
              </div>
            </span>
            <span>
              <div class="d-flex">
                <p class="tick"><img src="../../../../assets/ico/tick.svg" alt=""></p>
                <p>
                  O usuário root será o agente que está cadastrando a conta.
                </p>
              </div>
            </span>
            <span *ngFor="let detail of plans[1].details">
              <div class="d-flex">
                <p class="tick"><img src="../../../../assets/ico/tick.svg" alt=""></p>
                <p>
                  {{ detail.description }}
                </p>
              </div>
            </span>
          </div>
          <div class="categories">
          </div>
          <div class="mt-4 input d-flex flex-column gap-2 campaign-credit">
            <span>Adicione créditos de campanha</span>

            <div class="w-100 d-flex justify-content-center">

              <numeric-input class="mb-4" [(ngModel)]="creditBalance[1]" prefix="R$" [min]="1"></numeric-input>
            </div>
            <small class="text-muted">
              Total inicial: R$ {{ getDedicatedTotal(plans[1]) | number: "1.2-2" }}
            </small>
          </div>
        </div>
        <div class="w-100 action-button-container">
          <p class="terms-agreement">
            Ao contratar, eu concordo com os
            <button type="button" class="terms-agreement__link" (click)="viewPlanTerms(plans[1], 1, $event)">
              termos e condições
            </button>
            do produto.
          </p>
          <button (click)="hirePlan(plans[1], 1)" [disabled]="loadingTermForPlanIndex === 1"
            class="btn btn-lg btn-primary text-white">
            {{ loadingTermForPlanIndex === 1 ? 'Carregando termo...' : 'Contratar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4 col-12">
    <div class="card h-100">
      <div class="card-body d-flex flex-column align-items-center justify-content-between">
        <div class="w-100">
          <div class="plan-img">
            <img src="../../../../assets/ico/plan3.svg" alt="">
          </div>
          <div class="title">
            <span><strong>{{ plans[2].name }}</strong></span>
          </div>
          <div class="price-container d-flex flex-column">
            <span class="price-tag"><strong>R$
                <span class="price">{{
                  getValueByQnt(plans[2]) | number: "0.2-2"
                  }}</span>
                / 2026</strong></span>
            <span class="price-description text-muted">Taxa para ativação</span>
          </div>
          <div class="details">
            <div class="product-warning">
              {{ politicsCnaeWarning }}
            </div>
            <div *ngIf="qtdLicenses > 0">
            <span  *ngFor="let detail of plans[2].details">
              <div class="d-flex">
                <p class="tick"><img src="../../../../assets/ico/tick.svg" alt=""></p>
                <p>
                  {{ detail.description }}
                </p>
              </div>
            </span>
            </div>
          </div>
          <div class="mt-4 input d-flex flex-column gap-2">
            <span>Escolha a quantidade</span>
            <div class="w-100 d-flex justify-content-center">
              <numeric-input name="qtdLicenses" [(ngModel)]="qtdLicenses" [min]="0"></numeric-input>
            </div>
          </div>
          <!-- <div class="categories w-100">
            <p class="select-cate-title text-center">Selecione uma das opções:</p>
            <div class="form-check" *ngFor="let category of plans[2].categories; index as i">
              <input class="form-check-input" type="radio" [(ngModel)]="categorySelected" name="categories"
                [value]="category" [id]="'category_' + i" />
              <label class="form-check-label" [for]="'category_' + i">
                {{ category.name }}
              </label>
            </div>
          </div> -->
          <!-- <div class="details selected-categories" *ngIf="categorySelected">
            <span *ngFor="let detail of getPlanCategory(plans[2]).details">
              <div class="d-flex">
                <p class="tick"><img src="../../../../assets/ico/tick.svg" alt=""></p>
                <p>
                  {{ detail.description }}
                </p>
              </div>
            </span>
          </div> -->
        </div>
        <div class="w-100 action-button-container">
          <p *ngIf="isPollitcs" class="terms-agreement">
            Ao contratar, eu concordo com os
            <button type="button" class="terms-agreement__link" (click)="viewPlanTerms(plans[2], 2, $event)">
              termos e condições
            </button>
            do produto.
          </p>
          <button *ngIf="isPollitcs" (click)="hirePlan(plans[2], 2)" [disabled]="loadingTermForPlanIndex === 2"
            class="btn btn-lg btn-primary text-white">
            {{ loadingTermForPlanIndex === 2 ? 'Carregando termo...' : 'Contratar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
